<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="text-center">Upload Marketing Country Cost Data v2</h1>
      <h4 class="text-center cursor" @click="$router.push('/')">Go to V1</h4>
      <div class="card text-center mb-4" style="max-width: 600px; margin:auto">
        <div class="card-header text-center">
          APP
        </div>
        <div class="card-body">
          <div class="form-group">
            <select class="form-control text-center" v-model="app">
              <option :value="undefined" disabled>Choose App</option>
              <option v-for="(key, value) in apps" :value="value" :key="key">{{ key }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header text-center">
          Add Data
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-8">
              <form action="#">
                <label>Date</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="YYYY-MM-DD" maxlength="10" minlength="10" v-model="date">
                </div>
                <label>Country</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="__" maxlength="3" v-model="country">
                </div>
                <label>Platform</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="Ex: FB SKAD" v-model="platform">
                </div>
                <label>Cost</label>
                <div class="form-group">
                  <input type="number" class="form-control" placeholder="0.00" v-model.number="cost">
                </div>
                <label>Campaign Name</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="" v-model="campaign">
                </div>
                <label>Ad Set Name</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="" v-model="adgroup">
                </div>
                <label>Ad Name</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="" v-model="creative">
                </div>
              </form>
            </div>
            <div class="col-md-4">
              <label>Uploading from</label>
              <div class="form-group">
                <select class="form-control text-center" v-model="csvPlatform">
                  <option :value="undefined" disabled>Choose Platform</option>
                  <option v-for="(value, index) in platformOptions" :value="value" :key="`platform-select-${index}`">{{ value }}</option>
                </select>
              </div>
              <label>Upload CSV</label>
              <div>
                <input type="file" class="form-control" @change="importCSV">
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <button type="submit" class="btn btn-sm btn-fill btn-primary" @click="addRow()">Add new row to buffer</button>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header text-center">
          <h4 class="card-title">Buffer</h4>
        </div>
        <div class="card-footer text-center">
          <button type="submit" class="btn btn-sm btn-fill btn-success" @click="uploadToBigQuery">{{ uploadBtnText }}</button>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table tablesorter tablesorter-default tablesorter4f4f39ffa083a" id="simple-table" role="grid">
              <thead class=" text-primary">
                <tr role="row" class="tablesorter-headerRow">
                  <th data-column="0" class="col-md-1 tablesorter-header tablesorter-headerUnSorted" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Date: No sort applied, activate to apply an ascending sort" style="user-select: none;"><div class="tablesorter-header-inner">
                    DATE
                  </div></th>
                  <th data-column="1" class="col-md-1 tablesorter-header tablesorter-headerUnSorted" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Country: No sort applied, activate to apply an ascending sort" style="user-select: none;"><div class="tablesorter-header-inner">
                    COUNTRY
                  </div></th>
                  <th data-column="1" class="col-md-1 tablesorter-header tablesorter-headerUnSorted" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Country: No sort applied, activate to apply an ascending sort" style="user-select: none;"><div class="tablesorter-header-inner">
                    OS
                  </div></th>
                  <th data-column="1" class="col-md-7 tablesorter-header tablesorter-headerUnSorted" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Country: No sort applied, activate to apply an ascending sort" style="user-select: none;"><div class="tablesorter-header-inner">
                    TRACKER
                  </div></th>
                  <th class="col-md-1 text-center tablesorter-header tablesorter-headerUnSorted" data-column="2" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Cost: No sort applied, activate to apply an ascending sort" style="user-select: none;"><div class="tablesorter-header-inner">
                    COST
                  </div></th>
                  <th class="col-md-1 text-center tablesorter-header tablesorter-headerUnSorted" data-column="3" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Delete: No sort applied, activate to apply an ascending sort" style="user-select: none;">
                    <div class="tablesorter-header-inner">
                      DELETE
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody aria-live="polite" aria-relevant="all">
                <tr role="row" v-for="(item, index) in rows" :key="index">
                  <td>
                    {{ item.date }}
                  </td>
                  <td>
                    {{ item.country_code }}
                  </td>
                  <td>
                    {{ item.os_name }}
                  </td>
                  <td  class=" no-overflow">
                    {{ item.tracker_name}}
                  </td>
                  <td class="text-center">
                    ${{ item.cost }}
                  </td>
                  <td>
                    <div class="tablesorter-header-inner text-center">
                      <button class="btn btn-sm btn-danger" @click="removeRow(index)"> DEL </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import notify from "../util/notification";
import countryCodes from "@/assets/json/CountryCodes.json"
import tokenManagerService from "../services/tokenManager";

const isLocal = window.location.href.indexOf("localhost") >= 0
const backendUrl = isLocal ? "http://localhost:5002" : ""

export default {
  name: 'HomeV2Page',
  data() {
    return {
      app: undefined,
      date: undefined,
      country: undefined,
      platform: undefined,
      cost: undefined,
      campaign: undefined,
      adgroup: undefined,
      creative: undefined,
      platformOptions: ["facebook","tiktok", "google"],
      csvPlatform: undefined,
      state: 'waiting',
      rows: []
    }
  },
  computed: {
    apps() {
      return this.$store.getters.v2Apps
    },
    uploadBtnText() {
      if (this.state == 'waiting'){
        return "Upload Buffer to BigQuery"
      }else if (this.state == 'uploading'){
        return "Uploading to BigQuery..."
      }
    }
  },
  methods: {
    getOsFromCampaignName(campaign){
      let os;
      if (campaign.indexOf('ios') >= 0){
          os = "ios"
        }
        else if (campaign.indexOf('and') >= 0){
          os = "android"
        }
        else{
          os="undefined"
        }
        return os
    },
    addRow() {
      let isDateValid = true
      const date = new Date(this.date)
      if (!date.getTime()) {isDateValid = false}
      let isCountryValid = typeof this.country == 'string' && this.country.length >= 2 && this.country.length < 4
      let isCostValid = !Number.isNaN(this.cost) && this.cost >= 0 
      if (!isDateValid){
        notify('Date is not valid', 'error')
        return
      }

      if (!isCountryValid){
        notify('Country is not valid', 'error')
        return
      }

      if (!isCostValid){
        notify('Cost is not valid', 'error')
        return
      }
      const os = this.getOsFromCampaignName(this.campaign)

      this.rows.push({
        date: this.date,
        country_code: this.country,
        cost: this.cost,
        tracker_name: this.platform+'::'+this.campaign+'::'+this.adgroup+'::'+this.creative,
        os_name: os,
        impression: 0,
        click: 0,
        install: 0
      })
      this.date = undefined
      this.country = undefined
      this.platform = undefined
      this.cost = undefined
      this.campaign = undefined
      this.adgroup = undefined
      this.creative = undefined
    },
    removeRow(index) {
      this.rows.splice(index,1)
    },
    async uploadToBigQuery() {
      if (!this.app){
        notify('Please choose an app!', "error")
      }else{
        this.state = 'uploading'
        const token = await tokenManagerService.getValidToken()
        try {
          await axios.post(`${backendUrl}/load`, {
            data: this.rows,
            app: this.app
          }, {
            headers: {
              authorization: `Bearer ${token}`
            }
          })
          notify("Uploaded", "success")
          this.rows = []
          this.state = 'waiting'
        } catch (error) {
          notify("Couldn't upload", "error")
          this.state = 'waiting'
        }
      }
    },
    importCSV(event) {
      const reader = new FileReader();
      const vm = this
      reader.onload = function() {
        const contents = reader.result;
        const rows = contents.split('\r').join("").split('\n');
        rows.shift()
        vm.rows = vm.rows.concat(vm.getData(rows, vm.csvPlatform))
      };
      reader.readAsText(event.target.files[0]);
    },
    getData(rows, csvPlatform) {
      let result = []
      if (csvPlatform == 'facebook'){
        rows.forEach(row => {
          const [day, country, campaignName, adgroup, creative, cost] = row.split(',')
          if (cost && country && country != 'unknown'){
            const platform = 'facebook ads'
            const os = this.getOsFromCampaignName(campaignName)
            const row= {
              date: day,
              country_code: country,
              cost: Number(cost),
              os_name: os,
              tracker_name: platform+'::'+campaignName+'::'+adgroup+'::'+creative,
              impression: 0,
              click: 0,
              install: 0
            }
            result.push(row)
          }
        })
      }
      else if (csvPlatform == 'tiktok'){
        rows.forEach(row => {
          const [day, country, campaignName, adgroup, creative, cost] = row.split(',')
          if (cost && country && country != "-" && day){
            const platform = 'bytedanceglobal_int'
            const os = this.getOsFromCampaignName(campaignName)
            const row = {
              date: day,
              country_code: countryCodes[country],
              cost: Number(cost),
              os_name: os,
              tracker_name: platform+'::'+campaignName+'::'+adgroup+'::'+creative,
              impression: 0,
              click: 0,
              install: 0
            }
            result.push(row)
          }
        })
      }
      else if (csvPlatform == 'google'){
        rows.forEach(row => {
          const [day, country, campaignName, adgroup, currencyCode, cost] = row.split(',')
          if (cost && day != "Day"){
            const platform = "googleadwords_int"
            const os = this.getOsFromCampaignName(campaignName)
            const row = {
              date: day,
              country_code: countryCodes[country],
              cost: Number(cost),
              os_name: os,
              tracker_name: platform+'::'+campaignName+'::'+adgroup+'::'+adgroup,
              impression: 0,
              click: 0,
              install: 0
            }
            result.push(row)
          }
        })
      }
      return result;
    }
  }
}
</script>

<style>
.no-overflow{
  max-width: 0;
}
  
</style>